<template>
  <form
    :id="getFormId"
    class="klaviyo-form"
    :class="embedClass"
    data-ajax-submit="//manage.kmail-lists.com/ajax/subscriptions/subscribe"
    action="//manage.kmail-lists.com/subscriptions/subscribe"
    method="GET"
  >
    <input
      type="hidden"
      name="form_type"
      value="customer"
    >
    <input
      type="hidden"
      name="g"
      :value="listId"
    >
    <transition
      name="fade"
      mode="out-in"
    >
      <EmailInput
        v-if="!isSuccess"
        id="k_id_email"
        placeholder="Enter email"
      />
    </transition>
    <div class="klaviyo_messages">
      <div
        ref="form_success"
        class="success_message email-capture__notice email-capture__notice--success flex align-start flex-column"
        style="display:none;"
      >
        <p class="m-0">
          {{ getSuccessMessage(1) }}
        </p>
        <p class="m-0">
          {{ getSuccessMessage(2) }}
        </p>
      </div>
      <div
        class="error_message text-input__error-notice flex align-center"
        style="display:none;"
      />
    </div>
  </form>
</template>

<script>
// import Icon from "scripts/components/basic/Icon.vue";
import EmailInput from "scripts/components/forms/EmailInput.vue";

export default {
  components: {
    EmailInput
  },

  props: {
    formId: String,
    listId: String,
  },

  data() {
    return {
      isSuccess: false,
      notSubmitted: true,
      emailInput: ""
    };
  },

  computed: {
    embedClass() {
      return `klaviyo_standard_embed_${this.listId}`;
    },

    getFormId() {
      return this.formId ? this.formId : 'email_signup';
    },
  },

  mounted() {

    this.observeFormSuccess();

    if (this.listId) {
      const klaviyoInterval = setInterval(() => {
        // eslint-disable-next-line no-undef
        if (KlaviyoSubscribe) {
          clearInterval(klaviyoInterval);

          // eslint-disable-next-line no-undef
          KlaviyoSubscribe.attachToForms(`#${this.getFormId}`, {
            hide_form_on_success: true,
            custom_success_message: true,
          });
        }
      }, 500);
    }
  },

  methods: {
    getSuccessMessage(index) {
      return window.bvaccel.data[`klaviyo_success_message_${index}`];
    },

    observeFormSuccess() {
      const successMsg = this.$refs.form_success;
      const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          if (mutation.target.style.display !== "none") {
            this.isSuccess = true;
          }
        });
      });

      observer.observe(successMsg, {
        attributes: true,
        attributeFilter: ["style"]
      });
    }
  }
};
</script>

<style scoped lang="scss">
.klaviyo-form__input {
  margin: 0;
  max-width: unset;
}
</style>
